import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import { OPEN_SUPPORT_TICKETS_COLUMNS } from "./OpenSupportTickets.columns";

const OpenSupportTicketsTable = ({ data }) => (
  <div className="content-wrapper">
    <ReactTable
      showPagination
      className="-highlight calls"
      columns={OPEN_SUPPORT_TICKETS_COLUMNS}
      data={data}
      noDataText="No tickets found"
    />
  </div>
);

OpenSupportTicketsTable.propTypes = {
  data: PropTypes.array
};

export default OpenSupportTicketsTable;
